import src from "IMAGE";
export default { src, width: 1182, height: 767, blurWidth: 0, blurHeight: 0};
